"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientService = void 0;
const log_service_1 = require("./log.service");
const errors_1 = require("../models/constants/errors");
class ClientService {
    generateScript(sysLevel, params, config, maxRetry) {
        const logService = new log_service_1.LogService(sysLevel);
        let retries = 0;
        const logConfig = {
            id: config.id,
            src: config.src,
        };
        logService.addInfoLogToBuffer({
            event: 'fmf-script-request',
            data: {
                config: logConfig,
            },
        });
        const attachScriptDirectly = () => {
            const elem = document.createElement('script');
            return new Promise((resolve, reject) => {
                elem.id = config.id;
                elem.defer = config.defer;
                if (config.src) {
                    elem.src = config.src;
                }
                else {
                    elem.text = config.text;
                }
                if (config.scriptSrcConfs) {
                    elem.crossOrigin = config.scriptSrcConfs.crossOriginPolicy;
                }
                elem.onerror = (event) => {
                    document.head.removeChild(elem);
                    reject(JSON.stringify(event));
                };
                elem.onload = () => {
                    logService.addInfoLogToBuffer({
                        event: 'fmf-script-success',
                        data: {
                            config: logConfig,
                        },
                    });
                    resolve(true);
                };
                document.head.appendChild(elem);
            });
        };
        const attachScriptWithFetch = async () => {
            const elem = document.createElement('script');
            const request = {
                cache: 'no-cache',
                keepalive: true,
                referrerPolicy: 'strict-origin-when-cross-origin',
                headers: {
                    'Content-Type': 'text/javascript',
                },
            };
            if (config.scriptFetchConfs) {
                request.mode = config.scriptFetchConfs.modePolicy;
                request.credentials = config.scriptFetchConfs.credentialsPolicy;
            }
            if (config.src) {
                const data = await fetch(config.src, request);
                if (data.ok) {
                    const textData = await data.text();
                    elem.id = config.id;
                    elem.defer = config.defer;
                    elem.text = textData;
                    logService.addInfoLogToBuffer({
                        event: 'fmf-script-success',
                        data: {
                            config: logConfig,
                        },
                    });
                    document.head.appendChild(elem);
                    return true;
                }
                const jsonData = {
                    text: await data.text(),
                    status: data.status,
                    statusText: data.statusText,
                };
                throw jsonData;
            }
            throw errors_1.UndefinedSourceError;
        };
        const load = async () => {
            try {
                return config.isDirectScriptLoad ? await attachScriptDirectly() : await attachScriptWithFetch();
            }
            catch (error) {
                if (error === errors_1.UndefinedSourceError) {
                    retries = maxRetry;
                }
                const errorLog = !error
                    ? undefined
                    : typeof error === 'string'
                        ? error
                        : error.text
                            ? {
                                text: error.text,
                                status: error.status,
                                statusText: error.statusText,
                            }
                            : { error, message: error.message, stack: JSON.stringify(error.stack), name: error.name };
                if (retries < maxRetry) {
                    retries++;
                    logService.addErrorLogToBuffer({
                        event: 'fmf-script-retry',
                        error: errorLog,
                        attempt: retries,
                        data: {
                            config: logConfig,
                        },
                    });
                    return setTimeout(load, 500 * retries);
                }
                logService.addErrorLogToBuffer({
                    event: 'fmf-script-error',
                    error: errorLog,
                    data: {
                        config: logConfig,
                    },
                    message: config.scriptLoadErrorMessage,
                });
                return false;
            }
            finally {
                logService.sendAllLogs(params);
            }
        };
        return load();
    }
}
exports.ClientService = ClientService;
